import { render, staticRenderFns } from "./new-year-activity-statistics.vue?vue&type=template&id=0c5ab72c&scoped=true&"
import script from "./new-year-activity-statistics.vue?vue&type=script&lang=js&"
export * from "./new-year-activity-statistics.vue?vue&type=script&lang=js&"
import style0 from "./new-year-activity-statistics.vue?vue&type=style&index=0&id=0c5ab72c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5ab72c",
  null
  
)

export default component.exports